'use client';

import React from 'react';

import {
  ArrowSortUp20Filled,
  ArrowSortDown20Filled,
  ArrowSort20Filled,
} from '@fluentui/react-icons';
import type { Column } from '@tanstack/react-table';

import { cn } from '@avodah-inc/ui/utils';

import { Button, Typography } from '../../atoms';

type DataTableColumnHeaderProps<TData, TValue> = {
  column: Column<TData, TValue>;
  title: string;
  onSort?: (field: string, direction: 'asc' | 'desc') => void;
  sortDirection: 'asc' | 'desc' | null;
  sortField: string | null;
} & React.HTMLAttributes<HTMLDivElement>;

export const DataTableColumnHeader = <TData, TValue>({
  column,
  title,
  onSort,
  className,
  sortDirection,
  sortField,
}: DataTableColumnHeaderProps<TData, TValue>) => {
  if (!column.getCanSort()) {
    return <div className={cn(className)}>{title}</div>;
  }

  let buttonIcon;

  if (sortDirection === 'desc' && sortField === column.id.split('-')[0]) {
    buttonIcon = <ArrowSortDown20Filled className="text-gray-400" />;
  } else if (sortDirection === 'asc' && sortField === column.id.split('-')[0]) {
    buttonIcon = <ArrowSortUp20Filled className="text-gray-400" />;
  } else {
    buttonIcon = <ArrowSort20Filled className="text-gray-400" />;
  }

  const id = column.id.split('-')[0] ?? '';

  return (
    <div className={cn('flex items-center space-x-2', className)}>
      <Typography variant="h5">{title}</Typography>
      <Button
        onPress={() => {
          if (onSort) {
            onSort(id, sortDirection === 'asc' ? 'desc' : 'asc');
          }
        }}
        variant="text"
        className="flex h-8 items-center gap-2 text-black outline-none"
      >
        {buttonIcon}
      </Button>
    </div>
  );
};
